module.exports = __webpack_public_path__ + "media/images/application/template/products/homepage_small_containers_mob-317144cf8bc102080c587f52e89b00d2.png";